import { useState, useEffect } from "react";
import "./Preloader.css";

function Preloader() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Hide preloader after 5 seconds
    const startTime = Date.now();
    const minDisplayTime = 3000;

    const handleLoad = () => {
      const elapsed = Date.now() - startTime;
      const remainingTime = Math.max(0, minDisplayTime - elapsed);
      
      setTimeout(() => {
        setIsLoading(false);
      }, remainingTime);
    };

    if (document.readyState === "complete") {
      handleLoad();
    } else {
      window.addEventListener("load", handleLoad);
    }

    // Fallback: hide after 5 seconds even if page hasn't fully loaded
    const fallbackTimer = setTimeout(() => {
      setIsLoading(false);
    }, 5000);

    return () => {
      window.removeEventListener("load", handleLoad);
      clearTimeout(fallbackTimer);
    };
  }, []);

  if (!isLoading) return null;

  return (
    <div className="preloader">
      <div className="preloader-background"></div>
      <div className="preloader-content">
        <div className="preloader-logo">
          <div className="logo-glow"></div>
          <img src="/assets/logo.jpg" alt="Vinayak Agro Chemicals" />
        </div>
        <h1 className="preloader-title">
          <span>W</span><span>e</span><span>l</span><span>c</span><span>o</span><span>m</span><span>e</span> <span>T</span><span>o</span>
        </h1>
        <h2 className="preloader-subtitle">Vinayak Agro Chemicals</h2>
        <div className="preloader-spinner">
          <div className="spinner-outer"></div>
          <div className="spinner-middle"></div>
          <div className="spinner-inner"></div>
        </div>
        <div className="loading-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  );
}

export default Preloader;

